import React from "react";

import "./NotFound.css";

import NotFoundLogo from "./NotFoundLogo.svg";
function NotFound() {
  return (
    <div className="notfound">
      <img src={NotFoundLogo} className="notfound__logo" />
    </div>
  );
}

export default NotFound;
